export default __webpack_public_path__ + "static/kienzler-leistung-video-1-c67a8eb70b76d031248aea662d46555e.mp4";